import fp from 'lodash/fp';

export default fp.get(['data', 'result']);



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/getResult.js